import React from 'react';
import ProjectIssueTable from './projectIssueTable';

const ProjectIssueList = ({
    data,
    width,
    setProjectIssue,
    onDeleteProjectIssue,
    onSaveProjectIssue,
    showProjectIssueLoader,
}) => {
    return (
        <div className="app-main-content">
            <ProjectIssueTable
                data={data}
                width={width}
                setProjectIssue={setProjectIssue}
                onDeleteProjectIssue={onDeleteProjectIssue}
                onSaveProjectIssue={onSaveProjectIssue}
                showProjectIssueLoader={showProjectIssueLoader}
            />
        </div>
    );
};

export default ProjectIssueList;



// WEBPACK FOOTER //
// ./components/Agile/projectIssue/projectIssueList/index.js